"use strict";

define('filters',["jquery"], function ($) {

  var IS_ACTIVE = "is-active",
      $filterLinks = $(".filters"),
      $filterLink = $filterLinks.find('a');

  function attachEvents() {
    $filterLink.click(function(e){
      e.preventDefault();

      if($(this).hasClass(IS_ACTIVE)){
        $(this).removeClass(IS_ACTIVE);
      } else {
        $(this).addClass(IS_ACTIVE);
      }
    });
  }

  var initialize = function() {
    attachEvents();
  };

  return {
    init: initialize
  };

});

